<div *ngIf="text" class="commentIcon" [cupcakePopover]="popover">
  <i class="fa fa-comment"></i>
</div>
